import { useLayoutEffect } from "react";
import { TagsIcon } from "lucide-react";

import { Component as UpdateNodeComponent } from "@/app/app/_/commands/UpdateNodeCommand";
import { State } from "@/state";

export function ManageTagsCommand() {
  const registerCommandDefinition = State(
    (state) => state.registerCommandDefinition,
  );
  const unregisterCommandDefinition = State(
    (state) => state.unregisterCommandDefinition,
  );

  useLayoutEffect(() => {
    registerCommandDefinition({
      id: "manage-tags",
      title: "Manage Tags",
      description: "Manage tags for the active entity",
      component: UpdateNodeComponent,
      ReactIcon: TagsIcon,
      isResizable: true,
      sizes: ["sm", "md", "lg"],
      onClick: () => {
        const state = State.getState();
        const activeIdentifier =
          state.scopedEntityIdentifier ?? state.activeEntityIdentifiers?.[0];
        const entity = state.entities.find(
          (e) => e.identifier === activeIdentifier,
        );
        const tagGroupId = entity?.tagGroups?.[0]?.id;
        if (tagGroupId && entity) {
          state.pushToCommandStack({
            commandDefinitionId: "manage-tags",
            context: {
              nodeId: tagGroupId,
              entityIdentifier: entity.identifier,
            },
          });
        }
      },
    });

    return () => {
      unregisterCommandDefinition("manage-tags");
    };
  }, []);

  return null;
}
